// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"353":"contact","465":"crypto-grid","574":"footer","594":"about","933":"auth"}[chunkId] + "." + {"353":"8480e45c","465":"5cb8726b","574":"87f1d1fe","594":"cb1dc881","933":"137fb48d"}[chunkId] + ".chunk.css";
};